import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import TextField from "@mui/material/TextField";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";

const CustomDatePicker = ({ value, onChange, error, helperText, inputFormat = "YYYY-MM-DD", views, openTo, disableFuture = true, disabled, ...props }) => {
  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <DatePicker
        disableFuture={disableFuture}
        inputFormat={inputFormat}
        value={value || null}
        onChange={onChange}
        views={views}
        openTo={openTo}
        disabled={disabled}
        renderInput={(params) => (
          <TextField
            {...params}
            error={error}
            helperText={helperText}
            size="small"
            fullWidth
            disabled={disabled}
            {...props}
          />
        )}
      />
    </LocalizationProvider>
  );
};

export default CustomDatePicker;
